import { Box, useTheme } from '@mui/material';
import { FC } from 'react';

const notSet = 'not set';
export const NOT_SET = 'NOT_SET';
export const statusLabelOverrides: Partial<Record<string, string>> = {
  endContact: 'end-contact',
  opt_in: 'opt-in',
  dead: 'not interested',
  [NOT_SET]: notSet,
};

export const LeadStatusChip: FC<{ status: string | null; doNotOverrideText?: boolean }> = ({
  status,
  doNotOverrideText = false,
}) => {
  const theme = useTheme();

  if (!status) {
    return null;
  }

  const statusLowered = status.toLowerCase();

  let backgroundColor: string;
  let color = '#373d3b';
  let border: string | undefined = undefined;

  switch (statusLowered) {
    case 'confirmed':
    case 'transfer':
      backgroundColor = '#91E0C4';
      break;
    case 'cancelled':
    case 'undeliverable':
    case 'litigator':
    case 'dnc complainer':
    case 'dnc':
      backgroundColor = '#E99987';
      break;
    case 'flow':
    case 'opt-in':
    case 'rescheduled':
      backgroundColor = theme.palette.accent.purple;
      color = '#FFFFFF';
      break;
    case 'invalid phone':
      backgroundColor = '#F3DA99';
      break;
    case 'complete':
      backgroundColor = '#FFFFFF';
      border = '1px solid #91E0C4';
      break;
    case 'dead':
    default:
      backgroundColor = '#CBCED2';
      break;
  }

  return (
    <Box
      sx={{
        color,
        backgroundColor,
        border: border,
        borderRadius: '4px',
        fontSize: '10px',
        fontWeight: 'bold',
        height: '20px',
        paddingY: '2px',
        paddingX: '8px',
        whiteSpace: 'nowrap',
        display: 'inline-flex',
        alignItems: 'center',
        lineHeight: 'normal',
      }}
    >
      {doNotOverrideText
        ? status.toUpperCase()
        : statusLabelOverrides[status]?.toUpperCase() ?? status.toUpperCase()}
    </Box>
  );
};
